// import cn from 'classnames';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import useTab from "@hooks/useTab";
import { TabsList, TabsContent } from "@components/new/Tabs/Tabs";
import OrdersTabWithdrawal from "./OrdersTabWithdrawal";
import OrdersTabDelivery from "./OrdersTabDelivery";
import {
  useFBPRequestsCounter,
  useFBPWithdrawalRequestsCounter,
  TWarehouse,
  TSellerWarehouse,
} from "@api/apiClient/fbp";
import styles from './Tab.module.scss';

const OrdersTab = (props: {
  sellerWarehouse: TSellerWarehouse | undefined;
  activeWarehouse: TWarehouse | undefined;
  openCreateOrderModal: () => void;
}): ReactElement => {
  const { t } = useTranslation();
  const { data: requestsCounter } = useFBPRequestsCounter(props.sellerWarehouse?.id ?? "");
  const { data: withdrawalCounter } = useFBPWithdrawalRequestsCounter(props.sellerWarehouse?.id ?? "");

  const tabs = [
    {
      id: "Delivery",
      title: t('fbpPage.tabs.ApplicationsDelivery'),
      content: (
        <OrdersTabDelivery
          sellerWarehouse={props.sellerWarehouse}
          openCreateOrderModal={props.openCreateOrderModal}
          activeWarehouse={props.activeWarehouse}
        />
      ),
      count: requestsCounter ?? 0,
    },
    {
      id: "Withdrawal",
      title: t('fbpPage.tabs.ApplicationsWithdrawal'),
      content: (
        <OrdersTabWithdrawal
          sellerWarehouseId={props.sellerWarehouse?.id ?? ""}
          activeWarehouse={props.activeWarehouse}
        />
      ),
      count: withdrawalCounter ?? 0,
    },
  ];

  const { activeTab, setActiveTab } = useTab(tabs, "orders", ["tab", "sellerWarehouseId"]);

  return (
    <div className={styles.tabContent}>
      <div className={styles.tabsRow}>
        <TabsList
          tabs={tabs}
          onChange={setActiveTab}
          value={activeTab}
          type="badge"
        />
      </div>
      <TabsContent
        className={styles.tabContent}
        tab={tabs.find((tab) => (tab.id === activeTab))}
      />
    </div>
  );
};

export default OrdersTab;
